import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const Minimize2 = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className='lucide lucide-minimize2-icon lucide-minimize-2'
      >
        <path d='m14 10 7-7' />
        <path d='M20 10h-6V4' />
        <path d='m3 21 7-7' />
        <path d='M4 14h6v6' />
      </svg>
    </SvgIcon>
  );
};

export default Minimize2;
